// extracted by mini-css-extract-plugin
module.exports = {"root":"Benefits_root__WLN3D","popup":"Benefits_popup__6heKz","menu":"Benefits_menu__46XoQ","fadeIn":"Benefits_fadeIn__vq8in","spin":"Benefits_spin__3Nbkp"};